// Legacy LogoGallery has been migrated to dynamic database parameters.

export const AboutGallery = [
    {
        imgLow: require("./img/About/olivia_profile_low.jpg"),
        imgHigh: require("./img/About/olivia_profile_high.jpg"),
        description: ( "OliviaProfilePicture" ),
        hidden: false,
        link: "/about"
    },
    {
        imgLow: require("./img/About/Olivia_Logo_low.png"),
        imgHigh: require("./img/About/Olivia_Logo_high.png"),
        description: ( "OliviaLogo" ),
        hidden: false,
        link: "/home"
    }
];